<template>
  <div class="text-center loader">
    <div style="position: relative; top: 40%; color:black !important">
      <div 
        class="la-ball-spin-clockwise la-2x icon-wrapper">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading4',
};
</script>

<style lang="scss" src="./loading4.scss" scoped></style>
